import { render, staticRenderFns } from "./additional-services-booked.vue?vue&type=template&id=bfe9963c"
import script from "./additional-services-booked.vue?vue&type=script&lang=js"
export * from "./additional-services-booked.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports